import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';
import { useDonationFormsStore } from '../store';
import FormBuilderRenderer from './FormBuilderRenderer.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Gateways',
  props: [
  "gateways",
  "show_recurring",
  "strings",
  "use_form_builder",
  "form_builder_config"
],
  setup(__props, { expose: __expose }) {
  __expose();

const store = useDonationFormsStore();
const props = __props;

const setValue = (key, val) => {
  store[key] = val;
};

const setRecurring = (isRecurring: boolean) => {
  store.recurring = isRecurring;
  store.amount = 0; // Reset the amount
};

const selectedTestingInfo = computed(() => {
  const selected = store.payment_method;
  if (!selected || !props.gateways) return '';
  const list: any = props.gateways;
  const match: any = Array.isArray(list)
    ? list.find((g: any) => g && g.id === selected)
    : Object.values(list).find((g: any) => g && g.id === selected);
  return (match && match.testing_info) ? match.testing_info : '';
});

const getBack = () => {}


const __returned__ = { store, props, setValue, setRecurring, selectedTestingInfo, getBack, FormBuilderRenderer }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})